import { render, staticRenderFns } from "./_socialSecurityContribution.vue?vue&type=template&id=484776ee&"
import script from "./_socialSecurityContribution.vue?vue&type=script&lang=js&"
export * from "./_socialSecurityContribution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports